export var SupportedLanguage;
(function (SupportedLanguage) {
    SupportedLanguage["EN_US"] = "en_US";
    SupportedLanguage["PT_BR"] = "pt_BR";
})(SupportedLanguage || (SupportedLanguage = {}));
export var SupportedCurrency;
(function (SupportedCurrency) {
    SupportedCurrency["BRL"] = "BRL";
    SupportedCurrency["USD"] = "USD";
})(SupportedCurrency || (SupportedCurrency = {}));
/**
 * Countries the product is sold in — South America plus the US.
 *
 * Explicit and closed: the TypeBox enum, the generated client and the org-creation
 * select all derive from this tuple, so the set cannot drift between them. Display
 * names are localized from `country.<CODE>` keys; an unmapped code falls back to
 * the raw code. Adding a country is one entry here plus two locale keys.
 */
export const COUNTRY_CODES = [
    "BR",
    "PY",
    "UY",
    "AR",
    "CL",
    "BO",
    "CO",
    "US",
];
//# sourceMappingURL=Organization.js.map